import { get } from './index';
export const getSegments = () => get('/segments');
